import { descriptorPropTypes } from "lib/common/descriptorcontrols/formhelpers";
import EntityProxy from "data/util/EntityProxy";
import React from "react";
import PropTypes from "prop-types";
import Kids from "lib/dataentry/lib/dataentryform/formitems/Kids";

export class Layoutgridrow extends React.Component {
    render() {
        const {
            descriptor
        } = this.props;
        return (
            <tr
                key={descriptor.key}
                id={descriptor.id}
                className={`control-layout-${descriptor.key} control-layout-gridrow`}
            >
                <Kids {...this.props} controlOnly={false}/>
            </tr>
        );
    }

}

Layoutgridrow.propTypes = {
    descriptor: PropTypes.shape(descriptorPropTypes(null, false, true)),
    fluxContext: PropTypes.string.isRequired,
    activeRecord: PropTypes.instanceOf(EntityProxy).isRequired,
};

export default Layoutgridrow;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/formitems/Layout/gridrow.js